import { FuelGridItem, FuelTypography } from '@frete.com/fuel-react'
import { useTranslator } from '~hooks'
import { Text } from '~constants/text'

import * as Styled from './styled'
import { Props } from './interfaces'

function Reload({ reload }: Props) {
  const { translate } = useTranslator()

  return (
    <Styled.Wrapper data-testid="reload">
      <Styled.DangerIcon name="alert" size="medium" />
      <FuelTypography tag="p" size="body-md">
        {translate(Text.WRONG)}{' '}
        {reload && (
          <FuelGridItem>
            <Styled.ButtonReload data-testid="reload-button" onClick={reload}>
              {translate(Text.CLICK_HERE)}{' '}
            </Styled.ButtonReload>{' '}
            {translate(Text.TO_RECHARGE)}
          </FuelGridItem>
        )}
      </FuelTypography>
    </Styled.Wrapper>
  )
}

export default Reload
